
<div class="wrapper">

  <p class="display-1">
    404
  </p>

  <p class="h2">
    Page not Found
  </p>



  <div>
    <button mat-button class="doc-btn-success" (click)="back()"> Back</button>
  </div>

</div>